import axios from "axios";
import { base } from "../base";
import { getAttribution } from "../utils/attribution";

export const talentSignup = async (data) => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/talent/signup`,
    data: { ...data, attribution: getAttribution() },
  });
  return reponse;
};

export const talentLogin = async (data) => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/talent/login`,
    data: data,
  });
  return reponse;
};

export const talentVerifyOtp = async (otp) => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/talent/verify/otp`,
    data: {
      email: localStorage.getItem("email"),
      otp: otp,
    },
  });
  return reponse;
};

export const talentResetPass = async (data) => {
  const reponse = await axios({
    method: "PUT",
    url: `${base}/api/talent/forgot-password`,
    data: data,
  });
  return reponse;
};

export const talentUpdatePass = async (data) => {
  const reponse = await axios({
    method: "PUT",
    url: `${base}/api/talent/reset-password`,
    data: data,
  });
  return reponse;
};

export const talentResume = async (data, setProgress) => {
  const reponse = await axios({
    method: "PUT",
    url: `${base}/api/talent/upload-pdf`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
    onUploadProgress: (progressEvent) =>
      setProgress(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      ),
  });
  return reponse;
};

export const talentPersonalInfo = async (data) => {
  const response = await axios({
    method: "PATCH",
    url: `${base}/api/talent/personal/info`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  });
  return response;
};

export const talentEducation = async (data) => {
  const reponse = await axios({
    method: "PUT",
    url: `${base}/api/talent/education`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  });
  return reponse;
};

export const talentSkills = async (data) => {
  const reponse = await axios({
    method: "PUT",
    url: `${base}/api/talent/skills`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  });
  return reponse;
};

export const talentWorkHistory = async (data) => {
  const reponse = await axios({
    method: "PUT",
    url: `${base}/api/talent/work-history`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  });
  return reponse;
};

export const talentVideo = async (data, setProgress) => {
  const reponse = await axios({
    method: "PUT",
    url: `${base}/api/talent/video/upload`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
    onUploadProgress: (progressEvent) =>
      setProgress(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      ),
  });
  return reponse;
};

export const talentCompensation = async (data) => {
  const reponse = await axios({
    method: "PUT",
    url: `${base}/api/talent/work-compensation`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  });
  return reponse;
};

export const talentProfile = async () => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/talent/profile`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const talentRoles = async (page = 1) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/talent-roles/all`,
    params: {
      page: page
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }
  });
  return response;
};

export const talentGetCompanyProfile = async (id) => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/talent/client-info/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const talentApplyJob = async (jobId) => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/talent/jobs/apply/${jobId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};
export const getAllSelfDevelopment = async (category, page = 1) => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/talent/self-development`,
    params: {
      page: page,
      category: category
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const getJobByID = async (jobId) => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/talent/job/${jobId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const talentResendOtp = async () => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/talent/resendotp`,
    data: {
      email: localStorage.getItem("email"),
    },
  });
  return reponse;
};
export const talentInfo = async () => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/talent/talent_info`,
    data: {
      email: localStorage.getItem("email"),
    },
  });
  return reponse;
};

export const getNotifications = async (page = 1, limit = 10) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/notifications?page=${page}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};


export const markNotificationAsRead = async (notificationID) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/notifications/${notificationID}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const getUnreadCount = async () => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/notifications/unread-count`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const jobApplicants = async (page = 1) => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/talent/jobs/applicants/`,
    params: {
      page: page,
      order: "desc",
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const completeJob = async (jobID, data) => {
  const reponse = await axios({
    method: "PUT",
    url: `${base}/api/talent/jobs/complete/${jobID}`,
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};
export const closeJob = async (jobID, data) => {
  const reponse = await axios({
    method: "PUT",
    url: `${base}/api/talent/jobs/cancel/${jobID}`,
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const talentGoogleLogin = async (data) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/google`,
    data: data,
  });
  return response;
};

export const talentFacebookLogin = async (data) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/facebook`,
    data: data,
  });
  return response;
};

export const talentLinkedinLogin = async (data) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/linkedin`,
    data: data,
  });
  return response;
};
export const talentActivitySummary = async (page = 1, limit = 20) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/activity-summary`,
    params: { page, limit },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const uploadTalentProfilePhoto = async (id, data) => {
  const response = await axios({
    method: "PUT",
    url: `${base}/api/talent/profile/upload/avatar/${id}/`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};
export const talentJobAlert = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/talent/job-alert-preferences`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const talentCreateOrGetConversation = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/conversations/talent`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: {
      participantEmail: data.participantEmail,
      subject: data.subject,
    },
  });
  const conv = response.data?.data?.data || response.data?.data || response.data;
  if (!conv?._id) {
    return ("Invalid conversation response structure");
  }
  return response.data;
};

export const talentSendMessage = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/messages/talent`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: {
      conversationId: data.conversationId,
      receiverEmail: data.receiverEmail,
      content: data.content,
    },
  });

  return response.data;
};

export const talentDeleteConversation = async (conversationId) => {
  const response = await axios({
    method: "DELETE",
    url: `${base}/api/conversations/talent/${conversationId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const talentGetConversations = async (page = 1, limit = 6, search = "") => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/conversations/talent`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    params: {
      page,
      limit,
      ...(search ? { search } : {}),
    },
  });
  return response;
};

export const talentGetMessages = async (conversationId, page = 1, limit = 20) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/messages/talent`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    params: {
      conversationId: conversationId,
      page: page,
      limit: limit,
    },
  });

  const messages = response.data?.data?.messages || response.data?.messages;
  if (!messages) {
    return ("Invalid messages response structure");
  }

  return response.data;
};

export const talentMarkMessageAsRead = async (messageId) => {
  const response = await axios({
    method: "PUT",
    url: `${base}/api/messages/${messageId}/read`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const talentDeleteMessage = async (messageId) => {
  const response = await axios({
    method: "DELETE",
    url: `${base}/api/messages/talent/${messageId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const talentUpdateMessageStatus = async (messageId, status) => {
  const response = await axios({
    method: "PATCH",
    url: `${base}/api/messages/talent/${messageId}/status`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: {
      status: status,
    },
  });
  return response;
}
export const talentJobInteraction = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/talent/jobs/interaction`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const talentGetJobInteraction = async (interactionType, page = 1) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/jobs/interaction/${interactionType}`,
    params: {
      page: page,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const talentRemoveJobInteraction = async (jobId, interactionType) => {
  const response = await axios({
    method: "DELETE",
    url: `${base}/api/talent/jobs/interaction/${jobId}/${interactionType}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const publicJobs = async (page = 1, filter) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/public/jobs`,
    params: {
      page: page,
      ...filter
    },
  });
  return response.data;
};

export const submitPartnerAssessmentForm = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/public/form`,
    data: {
      source: data.source || "partnerships_enquiry",
      companyName: data.companyName,
      fullName: data.fullName,
      email: data.email,
      assesmentPerMonth: data.assesmentPerMonth,
      additionalComments: data.additionalComments,
      marketingConsent: data.marketingConsent === true,
      utm: data.utm,
      landingPage: data.landingPage,
    },
  });
  return response.data;
};

export const talentSuspendAccount = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/talent/account/suspend`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const talentUnsuspendAccount = async () => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/talent/account/unsuspend`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const talentDeleteAccount = async (data) => {
  const response = await axios({
    method: "PUT",
    url: `${base}/api/talent/account/delete`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      'Content-Type': 'application/json',
    },
  });
  return response;
};
export const talentGetMatchedJobs = async (page = 1) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/jobs/matched`,
    params: {
      page: page,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      'Content-Type': 'application/json',
    },
  });
  return response;
};

export const postSupportComplaint = async (data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/talent/support`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  });

  return response;
};

export const getSupportComplaints = async (page = 1, limit = 10) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/support?page=${page}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return response;
};

export const getSupportComplaintById = async (id) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/support/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return response;
};

export const replySupportComplaint = async (id, data) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/talent/support/reply/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  });
  return response;
};

export const getNotificationById = async (notificationID) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/notifications/${notificationID}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return response;
};

export const downloadAccountPDF = async () => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/account/download-pdf`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    responseType: 'blob'
  });
  return response;
};


export const downloadJobDataPDF = async () => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/talent/job-data/download-pdf`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    responseType: 'blob'
  });
  return response;
};

export const talentUploadPdf = async (data) => {
  const response = await axios({
    method: "PUT",
    url: `${base}/api/talent/upload-pdf`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data
  });
  return response;
};

export const getTalentCurrentTest = async () => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/talent/psychometric/test`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const getTalentTestAnswers = async () => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/talent/psychometric/answers`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const getTalentJobFeed = async (page = 1) => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/talent/jobs/all`,
    params: {
			page: page,
		},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const submitTalentCurrentTest = async (data, action = "submit") => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/talent/psychometric/test/submit?action=${action}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  });
  return reponse;
};

export const downloadTalentProfile = async () => {
  const reponse = await axios({
    method: "GET",
    responseType: 'blob',
    url: `${base}/api/talent/talent-profile`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};


export const talentSubscribe = async (subscriptionId) => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/subscription/${subscriptionId}/subscribe/talent`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};


export const getTalentPaymentHistory = async () => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/subscription/talent/payment-history`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const getTalentImprovementTest = async () => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/talent/improvement/test`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const getTalentImprovementAnswers = async () => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/talent/improvement/results`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return reponse;
};

export const submitTalentImprovementTest = async (data, attemptId) => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/talent/improvement/test/submit/${attemptId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data,
  });
  return reponse;
};

export const getTalentSubscription = async (page = 1) => {
  const reponse = await axios({
    method: "GET",
    url: `${base}/api/subscription/talent`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    params: {
      page: page,
    },
  });
  return reponse;
};

export const submitTalentImprovementSkills = async (data) => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/talent/improvement/skills/submit`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data,
  });
  return reponse;
};

export const findTalentSubscription = async (data) => {
  const reponse = await axios({
    method: "POST",
    url: `${base}/api/subscription/find/talent`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data,
  });
  return reponse;
};

export const talentWhatsappNotification = async () => {
  const response = await axios({
    method: "PATCH",
    url: `${base}/api/talent/whatsapp-notification`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
  return response;
};